module.exports = __webpack_public_path__ + "static/media/platforms-android.a81d3809.svg";